import { defineComponent as V, openBlock as o, createElementBlock as a, mergeProps as p, unref as e, renderSlot as i, createElementVNode as n, createCommentVNode as u } from "vue";
import { useScalarIcon as g } from "../hooks/useScalarIcon.js";
const H = { key: 0 }, m = { key: 1 }, M = { key: 2 }, Z = { key: 3 }, f = { key: 4 }, k = { key: 5 }, v = {
  name: "ScalarIconParagraph"
}, _ = /* @__PURE__ */ V({
  ...v,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const h = r, { bind: s, weight: l } = g(h);
    return (d, t) => (o(), a("svg", p({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(s)), [
      i(d.$slots, "default"),
      e(l) === "bold" ? (o(), a("g", H, t[0] || (t[0] = [
        n("path", { d: "M208,36H96a68,68,0,0,0,0,136h36v36a12,12,0,0,0,24,0V60h16V208a12,12,0,0,0,24,0V60h12a12,12,0,0,0,0-24ZM132,148H96a44,44,0,0,1,0-88h36Z" }, null, -1)
      ]))) : e(l) === "duotone" ? (o(), a("g", m, t[1] || (t[1] = [
        n("path", {
          d: "M144,48V160H96A56,56,0,0,1,96,48Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M208,40H96a64,64,0,0,0,0,128h40v40a8,8,0,0,0,16,0V56h24V208a8,8,0,0,0,16,0V56h16a8,8,0,0,0,0-16ZM136,152H96a48,48,0,0,1,0-96h40Z" }, null, -1)
      ]))) : e(l) === "fill" ? (o(), a("g", M, t[2] || (t[2] = [
        n("path", { d: "M216,48a8,8,0,0,1-8,8H192V208a8,8,0,0,1-16,0V56H152V208a8,8,0,0,1-16,0V168H96A64,64,0,0,1,96,40H208A8,8,0,0,1,216,48Z" }, null, -1)
      ]))) : e(l) === "light" ? (o(), a("g", Z, t[3] || (t[3] = [
        n("path", { d: "M208,42H96a62,62,0,0,0,0,124h42v42a6,6,0,0,0,12,0V54h28V208a6,6,0,0,0,12,0V54h18a6,6,0,0,0,0-12ZM138,154H96A50,50,0,0,1,96,54h42Z" }, null, -1)
      ]))) : e(l) === "regular" ? (o(), a("g", f, t[4] || (t[4] = [
        n("path", { d: "M208,40H96a64,64,0,0,0,0,128h40v40a8,8,0,0,0,16,0V56h24V208a8,8,0,0,0,16,0V56h16a8,8,0,0,0,0-16ZM136,152H96a48,48,0,0,1,0-96h40Z" }, null, -1)
      ]))) : e(l) === "thin" ? (o(), a("g", k, t[5] || (t[5] = [
        n("path", { d: "M208,44H96a60,60,0,0,0,0,120h44v44a4,4,0,0,0,8,0V52h32V208a4,4,0,0,0,8,0V52h20a4,4,0,0,0,0-8ZM140,156H96A52,52,0,0,1,96,52h44Z" }, null, -1)
      ]))) : u("", !0)
    ], 16));
  }
});
export {
  _ as default
};
